import { Reveal } from '../components/Reveal';

const stages = [
  { n: '01', title: 'DISCOVER', copy: 'We listen, map and understand your processes, systems, suppliers and customers.' },
  { n: '02', title: 'DESIGN', copy: 'We shape the solution around your workflows, exceptions and service model.' },
  { n: '03', title: 'BUILD', copy: 'We develop, integrate and configure Relay in your environment, with your teams.' },
  { n: '04', title: 'DELIVER', copy: 'We support, refine and evolve as your operation grows and changes.' },
];

export const Approach = () => (
  <section id="approach" className="scroll-mt-20 py-20 md:py-28" data-testid="approach-section">
    <div className="container-relay">
      <Reveal className="max-w-2xl">
        <p className="eyebrow mb-4" data-testid="approach-eyebrow">Our approach</p>
        <h2 className="text-3xl font-bold tracking-tight text-[#111111] sm:text-4xl" data-testid="approach-headline">
          We embed. We understand.
          <br />
          We build what fits.
        </h2>
        <p className="mt-5 max-w-[54ch] text-base leading-relaxed text-[#6B7280]" data-testid="approach-body">
          We embed with your teams for as long as it takes to understand your operation from the inside out. Then
          we design, build and configure Relay around your real workflows — not the other way around.
        </p>
      </Reveal>
      <div className="relative mt-16">
        <div className="absolute left-0 right-0 top-[26px] hidden border-t border-dashed border-[#D1D5DB] md:block" aria-hidden="true" />
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 md:grid-cols-4 md:gap-6">
          {stages.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.14}>
              <div data-testid={`approach-stage-${s.n}`} className="relative">
                <div className="relative z-10 mb-5 flex h-[52px] w-[52px] items-center justify-center rounded-full border border-[#0F5C4A] bg-[#FAFAF7]">
                  <span className="font-op text-sm font-semibold text-[#0F5C4A]">{s.n}</span>
                </div>
                <p className="font-op text-xs font-semibold uppercase tracking-[0.22em] text-[#111111]">{s.title}</p>
                <p className="mt-2.5 text-sm leading-relaxed text-[#6B7280]">{s.copy}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
